var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{staticClass:"pa-5 pb-2"},[_c('p',{staticClass:"text-h6"},[_vm._v(_vm._s(_vm.headerText))])]),_c('v-row',{staticClass:"px-4 mb-4"},[_c('v-divider')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }